import { ActionCardModel, QuestionNode, GenericAiWidgetNode } from '../actionCard'

const dangerousTags = [
  '<applet',
  '<style',
  '<link',
  '<iframe',
  '<script',
  '<img',
  '<video',
  '<comment',
  '<embed',
  '<link',
  '<listing',
  '<meta',
  '<noscript',
  '<object',
  '<plaintext',
  '<script',
  '<xmp',
  'onmouseover=',
  'onerror=',
]

export class ReplacementProcessor {
  private __actionCardModel: ActionCardModel
  private __replacementsMap?: { key: string; value: string }[]

  private get __ReplacementsMap() {
    if (!this.__replacementsMap) {
      this.__replacementsMap = this.__getReplacementsMap()
    }

    return this.__replacementsMap
  }

  constructor(actionCardModel: ActionCardModel) {
    this.__actionCardModel = actionCardModel
  }

  public processReplacements(text: string): string {
    if (!text || !text.includes('$')) {
      return text
    }

    this.__ReplacementsMap.forEach(({ key, value }: { key: string; value: string }) => {
      text = text.replaceAll(key, value)
    })
    return text
  }

  private __getReplacementsMap(): { key: string; value: string }[] {
    const map: { key: string; value: string }[] = []

    const searchService = this.__actionCardModel.getSearchService()

    // add to the map QuestionNode values
    searchService.filterQuestions().forEach<QuestionNode>(questionNode => {
      const code = questionNode.getCode()
      if (code) {
        map.push({ key: '$'.concat(code), value: this.__getReplacementValue(questionNode) })
      }
    })

    // add to the map GenericAiWidgetNode values
    searchService
      .filter(x => x instanceof GenericAiWidgetNode)
      .forEach<GenericAiWidgetNode>(widgetNode => {
        const code = widgetNode.getCode()
        if (code) {
          let value = widgetNode.getValue()
          value = !value || dangerousTags.some(tag => value?.includes(tag)) ? '' : value
          map.push({ key: '$'.concat(code), value: value || '' })
        }
      })

    return map
  }

  private __getReplacementValue(questionNode: QuestionNode): string {
    const replacementValue =
      questionNode.stringifyValue() || `(${questionNode.getLabelTemplate()})` || questionNode.getType()
    return dangerousTags.some(tag => replacementValue.includes(tag)) ? '' : replacementValue
  }
}
